import { Resources } from './../../../../../models/resources';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PlyrComponent } from 'ngx-plyr';
import * as jquery from 'jquery';
import { UserService } from 'src/app/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { map, tap } from 'rxjs/operators';
import { Role } from 'src/app/models';
import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';
import { AdminService } from 'src/app/services/admin.service';
import { AuthService } from 'src/app/services/auth.service';
import { PortfolioNavigationComponent } from 'src/app/partials/navigation/portfolio-navigation/portfolio-navigation.component';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {

  @ViewChild(PlyrComponent, { static: true }) plyr: PlyrComponent;
  @ViewChild(UserNavigationComponent) userNavigation;
  @ViewChild(PortfolioNavigationComponent) portfolioNavigation;

  videoPlayer: Plyr;
  videoSource = '';
  modalText = 'Loading...';
  resourceId = 0;
  resource: Resources = new Resources();
  nonAdminRoles = [Role.Individual, Role.Manager, Role.Employee];

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private adminService: AdminService,
    public authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.getRouteParams();

    const currentRole = this.authService.currentUserValue.role;
    if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
      this.getUser();
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.getAdmin();
          } else {
            this.getUser();
          }
        });
    }
  }

  private getRouteParams() {
    this.resourceId = this.route.snapshot.params.id;
  }

  private getUser() {
    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.portfolioNavigation.user = user;
        }),

      )
      .subscribe(
        response => {
          if (response) {
            this.getResource();
          }
        },
        error => { }
      );
  }

  private getAdmin() {
    this.adminService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.portfolioNavigation.user = user;
        }),

      )
      .subscribe(
        response => {
          if (response) {
            this.getResource();
          }
        },
        error => { }
      );
  }

  private getResource(): void {
    this.showProgressModal();
    this.userService.getResource(this.resourceId)
      .subscribe(response => {
        this.hideProgressModal();

        if (response.data.hasOwnProperty('resource')) {
          this.resource = response.data.resource;
          this.videoSource = this.resource.link_url;
        }

      });
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
